import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";

import menuLine from "../../Assets/menu-line.svg"
import close from "../../Assets/add.svg"
import { IconGlobe } from "../../Assets/IconGlobe";
import { IconUser } from "../../Assets/IconUser";
import { havePermission } from "../Functions/PermissionCheck";

const Style = styled.div`
    min-height: 100vh;
    width: 100vw;
    z-index: 100;
    display: flex;
    flex-direction: column;
    position: relative;
    background-color: var(--n-grey-01);
    * {
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto",
            "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
            sans-seri;
    }
    &.persian-font {
        * {
            font-family: iranyekan;
        }
    }
    .content {
        flex-grow: 1;
        min-height: 100svh;
    }
    .navpad {
        position: relative;
        height: 80px;
        width: 100%;
    }
    .navbar {
        width: calc(100% - calc(var(--universal-pad) * 2));
        z-index: 999;
        box-shadow: 0px 4px 50px -14px #00000028;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        padding: 0 var(--universal-pad);
        height: 60px;
        position: fixed;
        inset: 0 0 auto 0;
        background: var(--nav-bg);
        backdrop-filter: blur(30px);
        transition: all 0.15s ease-in-out;
        &.big {
            height: 80px;
            .logo {
                padding: 0;
                height: 50px;
            }
            .login {
                .desc-text {
                    font-size: 16px;
                }
            }
        }
        .logo {
            align-self: center;
            height: 40px;
            min-width: 25%;
            padding: 0 0;
            transition: all 0.15s ease-in-out;
            img {
                height: 100%;
            }
        }
        .menu-btn {
            display: none;
        }
        .expand {
            flex-grow: 1;
        }
        .user-container {
            cursor: pointer;
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding: 0 0;
            text-decoration: none;
            color: var(--fsc-d-1);
            font-size: 14px;
            position: relative;
            min-width: 150px;
            align-items: flex-end;
            .title {
                width: fit-content;
                border-radius: var(--border-radius-3);
                border: 1px solid var(--n-grey-1);
                background-color: var(--n-grey-01);
                color: var(--n-grey-2);
                padding: 4px 8px;
                display: flex;
                align-items: center;
                gap: 6px;
                font-weight: 700;
                text-decoration: none;
                svg {
                    fill: var(--n-grey-2);
                }
            }
            .items {
                box-shadow: 0px 4px 50px -14px #00000028;
                display: none;
                flex-direction: column;
                position: absolute;
                top: calc(100% - 5px);
                left: 0;
                background-color: var(--n-grey-01);
                border: 1px solid var(--n-grey-1);
                padding: 4px 8px;
                border-radius: 1rem;
                width: calc(100% + 16px);
                min-width: 150px;
                &.ltr {
                    left: auto;
                    right: 0;
                }
                .login-item {
                    display: flex;
                    align-items: center;
                    gap: 4px;
                    text-decoration: none;
                    color: inherit;
                    padding: 4px 0;
                    .icon {
                        img {
                            display: block;
                        }
                    }
                }
            }
            &:hover {
                .items {
                    display: flex;
                }
            }
        }
        .change-lan {
            cursor: pointer;
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding: 0 0;
            text-decoration: none;
            color: var(--fsc-d-1);
            font-size: 14px;
            position: relative;
            .title {
                border-radius: var(--border-radius-3);
                border: 1px solid var(--n-grey-1);
                padding: 4px 8px;
                display: flex;
                align-items: center;
                gap: 6px;
                background-color: var(--n-grey-01);
                font-weight: 700;
                color: var(--n-grey-2);
                svg {
                    fill: var(--n-grey-2);
                }
            }
            .items {
                position: absolute;
                display: none;
                flex-direction: column;
                top: calc(100% - 10px);
                right: -20px;
                left: -20px;
                background-color: #fff;
                padding: 2px;
                border-radius: 10px;
                box-shadow: 0px 4px 8px -2px #0000005f;
                .item {
                    text-decoration: none;
                    padding: 0.5rem 1rem;
                    text-align: center;
                    border-radius: 8px;
                    color: #000;
                    margin: 0 0;
                    border:1px solid #fff;
                    :first-child {
                        margin: 0 0 0.3rem;
                    }
                    :last-child {
                        margin: 0.3rem 0 0;
                    }
                    &.active {
                        background-color: #eee;
                        border:1px solid #ccc;
                    }
                }
            }
            &:hover {
                .items{
                    display: flex;
                }
            }
        }
        .items {
            display: flex;
            justify-content: center;
            width: 100%;
            margin: auto;
            .navitem {
                cursor: pointer;
                display: flex;
                flex-direction: column;
                justify-content: center;
                padding: 0 1rem;
                text-decoration: none;
                color: var(--n-grey-2);
                font-size: 14px;
                position: relative;
                .drop-data {
                    z-index: 5;
                    position: absolute;
                    display: none;
                    flex-direction: column;
                    top: calc(100% + 0px);
                    right: -50px;
                    left: -50px;
                    background-color: #fff;
                    padding: 2px;
                    border-radius: 10px;
                    box-shadow: 0px 4px 8px -2px #0000005f;
                    .navitem {
                        text-decoration: none;
                        padding: 0.5rem 0.5rem;
                        text-align: center;
                        border-radius: 8px;
                        color: #000;
                        margin: 0.3rem 0;
                        border:1px solid #fff;
                        :first-child {
                            margin: 0 0 0.3rem;
                        }
                        :last-child {
                            margin: 0.3rem 0 0;
                        }
                        &.active {
                            background-color: #eee;
                            border:1px solid #ccc;
                        }
                        &&:hover {
                            border:1px solid #ccc;
                        }
                    }

                }
                &:hover {
                    .drop-data {
                        display: flex;
                    }
                }
                &.active {
                    font-weight: 700;
                    color: var(--prime-1);
                }
            }
        }
        .far-side {
            min-width: 25%;
            display: flex;
            gap: 0.5rem;
            flex-direction: row;
            justify-content: flex-end;
        }
    }
    .footer {
        color: var(--fsc-d-1);
        padding: 32px var(--universal-pad);
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        position: relative;
        background: var(--nav-bg);
        backdrop-filter: blur(30px);
        box-shadow: 0px -4px 50px -14px #00000028;
        .container-1 {
            width: 25%;
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
            .logo {
                img {
                    height: 50px;
                }
            }
            .desc {
                color: var(--n-grey-2);
            }
        }
        .container-2 {
            width: calc(50% - 4rem);
            margin: 0 2rem;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;
            gap: 1.5rem;
            color: var(--n-grey-2);
            .navitem {
                max-width: calc(100% / 6);
                display: flex;
                flex-direction: column;
                justify-content: center;
                padding: 0.5rem 0;
                text-decoration: none;
                white-space: nowrap;
                color: var(--n-grey-2);
                font-size: 14px;
                font-weight: 500;
            }
        }
        .container-3 {
            width: 25%;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            .logos {
                width: 100px;
                height: 100px;
                a {
                    border-radius: var(--border-radius-2);
                    display: block;
                    width: 80px;
                    padding: 0.5rem;
                    background-color: var(--n-grey-1);
                    img {
                        display: block;
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                    }
                }
            }
        }
    }
    .down{
        padding: 0.5rem 0;
        text-align: center;

        color: var(--fsc-d-1);
        background: var(--nav-bg);
        backdrop-filter: blur(30px);
        font-size: 0.7rem;
        a {
            color: var(--text-d-1);
            text-decoration: none;
            &:hover {
                color: var(--n-grey-1)
            }
        }
    }
    @media (max-width: 850px){
        .navbar {
            width: calc(100vw - 32px);
            padding: 0 16px 0;
            justify-content: end;
            &.big {
                .logo {
                    padding: 20px 0;
                    height: 40px;
                }
            }
            .expand {
                display: none;
            }
            .logo {
                min-width: 150px;
                padding: 10px 0;
                position: absolute;
                top: 0;
                left: calc(50% - 75px);
                display: flex;
                flex-direction: row;
                justify-content: center;
            }
            .items {
                display: none;
            }
            .change-lan {
                display: none;
            }
            
            .menu-btn {
                z-index: 980;
                overflow: visible;
                cursor: pointer;
                position: fixed;
                top: 10px;
                right: 16px;
                width: 40px;
                height: 40px;
                background-color: #fff;
                display: flex;
                justify-content: center;
                border-radius: 4px;
                transition: all 0.15s ease-in-out;
                border-radius: var(--border-radius-3);
                border: 1px solid var(--n-grey-1);
                background-color: var(--n-grey-01);
                color: var(--n-grey-2);
                &.ltr {
                    right: auto;
                    left: 16px;
                    .menu-container {
                        right: auto;
                        left: -80vw;
                        &.active {
                            left: 0vw;
                        }
                    }
                }
                &.big {
                    top: 20px;
                    width: 40px;
                    height: 40px;
                }
                .menu-btn-img {
                    width: 20px;
                    height: 20px;
                    margin: auto;
                    transition: all 0.3s ease-in-out;
                    &.big {
                        width: 23px;
                        height: 23px;
                    }
                }
                .bg {
                    z-index: 950;
                    position: fixed;
                    inset: 0 0 0 0;
                    width: 100vw;
                    height: 100vh;
                    background-color: #0000005f;
                }
                .menu-container {
                    z-index: 970;
                    display: flex;
                    flex-direction: column;
                    position: fixed;
                    background-color: var(--n-grey-01);
                    width: 80vw;
                    height: 100vh;
                    inset: 0 0 0 auto;
                    right: -80vw;
                    transition: all 0.3s ease-in-out;
                    &.active {
                        right: 0vw;
                    }
                    .logo-menu {
                        width: 40%;
                        margin: 70px auto 35px;
                        img {
                            width: 100%;
                            height: auto;
                        }
                    }
                    .menu-items {
                        display: flex;
                        flex-direction: column;
                        .navitem {
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            padding: 1rem;
                            text-decoration: none;
                            color: var(--fsc-d-1);
                            font-size: 16px;
                            border-bottom: 1px solid var(--bg-d-3);
                            :last-child{
                                border-bottom: none;
                            }
                            &.active {
                                background-color: #fff;
                                font-weight: 700;
                            }
                        }
                    }
                    .text-s {
                        margin: 1rem auto 0.5rem;
                    }
                    .change-lan {
                        display: flex;
                        flex-direction: column;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        color: var(--fsc-d-1);
                        font-size: 16px;
                        margin: 0 1rem;
                        .title {
                            padding: 1rem;
                        }
                        .items {
                            position: relative;
                            inset: 0;
                            display: flex;
                            flex-direction: column;
                            background-color: #fff;
                            padding: 2px;
                            border-radius: 10px;
                            box-shadow: none;
                        }
                    }
                    .socials {
                        margin: 0.5rem auto 5rem;
                        display: flex;
                        flex-direction: row;
                        .item {
                            margin: 0 0.5rem;
                            :last-child{
                                margin: 0 0.5rem 0 0;
                            }
                            :first-child{
                                margin: 0 0 0 0.5rem;
                            }
                        }
                    }
                }
                
            }
        }
        .footer {
            padding: 32px 16px;
            width: calc(100% - 32px);
            flex-direction: column;
            gap: 2rem;
            .container-1 {
                align-items: center;
                width: 100%;
            }
            .container-2 {
                width: 100%;
                margin: 0;
                .navitem {
                    max-width: calc(100% / 2);
                }
            }
            .container-3 {
                width: 100%;
                justify-content: center;
            }
        }
    }
`;


export default function PageLayout(props) {
    const location = useLocation();
    const [open, setOpen] = useState(false)
    const [top, setTop] = useState(1);
    const [scroll, setScrollState] = useState(0);

    useEffect(() => {
        document.addEventListener('scroll', setScroll);
        return () => {
            document.removeEventListener('scroll', setScroll);
        }
    }, [])
    const setScroll = (e) => {
        setScrollState(window.scrollY)
    }
    useEffect(()=> {
        if (scroll > 30) {
            if(top === 1){
                setTop(0)
            }
        } else {
            setTop(1)
        }
    }, [scroll, top]);

    const makeNavItems = (nav = props.nav) => {
      return nav.map((value, index) => {
             if(value.type === 'multi') {
                let dropData = makeNavItems(value.links);
                return (
                    <div className={"navitem" + ((location.pathname === '/' + lan + value.route) ? ' active' : '')} onClick={openMenu} key={index}>
                        {value.title[lan]}
                        <div className="drop-data">{dropData}</div>
                    </div>
                )
            }
            let link = value.route;
            if(link.length > 5) {
                let first = link.search("http");
                if(first !== -1 && first < 4) {
                    return ''
                    // (
                    //     <a href={value.route} target={value.target} className={"navitem" + ((location.pathname === value.route) ? ' active' : '')} key={index}>
                    //         {value.title[lan]}
                    //     </a>
                    // )
                }
            }
           
            return (
                <Link to={'/' + lan + value.route} className={"navitem" + ((location.pathname === '/' + lan + value.route) ? ' active' : '')} onClick={openMenu} key={index}>
                    {value.title[lan]}
                </Link>
            )
        })
    }
    const makeFooterItems = () => {
        return props.footer.map((value, index) => {
            let link = value.route;
            if(link.length > 5) {
                let first = link.search("http");
                if(first !== -1 && first < 4) {
                    return (
                        <a href={value.route} target={value.target} className={"navitem" + ((location.pathname === value.route) ? ' active' : '')} key={index}>
                            {value.title[lan]}
                        </a>
                    )
                }
            }
            return (
                <Link to={'/' + lan + value.route} className={"navitem" + ((location.pathname === value.route) ? ' active' : '')} key={index}>
                    {value.title[lan]}
                </Link>
            )
        })
    }
    
    const openMenu = () => {
        setOpen(!open)
    }
    const makeLang = (lan) => {
        let pathname = location.pathname
        
        // let search = location.state.
        if(lan !== ''){
            localStorage.setItem("lang", lan);
            pathname = pathname.split('/');
            pathname.splice(1, 1);
            if(pathname.length === 1){
                pathname = ['', '']
            }
            pathname = pathname.join('/')
            if(location.search){
                pathname = pathname + location.search
            }
        }
        return props.dict.map((value, index) => {
            return (
                <a 
                    href={'/' + value.filename + pathname} 
                    className={"item" + ((value.filename === lan) ? " active": '')} 
                    key={index}
                >
                    {value.title}
                </a>
            )
        })
    }
    const ctaNav = (lan, direction) => {
        if(props.user.U_EMAIL){
            // logined // menus
       
            let filtered = props.login.ctas.filter((v) => {
                    //  console.log(v)
                if(!v.premission){
                    return true
                }
                if(!v.premission.length){
                    return true
                }
                for (let i = 0; i < v.premission.length; i++) {
                    const per = v.premission[i];
                    if(per === "admin"){
                        return havePermission(props.user.permission, {Agency_Id: 0, Obj_Code: 1})
                    }
                }
                return false;
            })
            let ctas = filtered.map((v,i) => {
                return (
                    <a href={"/"+lan+v.route} target={v.target} key={i} className="login-item">
                        <div className="icon">
                            <img src={v.icon} alt={v.title[lan]}/>
                        </div>
                        <div className="spacer">
                        </div>
                        <div className="text">
                            {v.title[lan]}
                        </div>
                    </a>
                )
            })
            return (
                <div className="user-container">
                    <div className="title">
                        <IconUser/>
                    </div>
                    <div className={"items "+ direction}>
                        {ctas}
                    </div>
                </div>
            )

        }
        return (
            <div className="user-container">
                <Link to={"/"+ lan +"/login"} className="title">
                    <IconUser/>
                    {props.login.title[lan]}
                </Link>
            </div>
        )
    }

    let direction = 'ltr';
    let lan = props.language.filename;
    let lanName = props.language.title;
    if(props.language.dir) {
        direction = props.language.dir
    }
    return (
        <Style className={((props.language.dir === "rtl") ? 'persian-font' : '')} style={{direction: direction ,fontFamily: ((props.language.dir) ? 'iranyekan' : '')}}>
            <div className={"navbar" + (top ? " big" : "")}>
                <Link to="/" className="logo">
                    <img src={props.mainLogo} alt="farazandishan"/>
                </Link>
                <div className="items" style={{direction: (lan === 'en' ? 'ltr' :'rtl')}}>
                    {makeNavItems()}
                </div>
                <div className="expand"></div>
                <div className="far-side">
                    {ctaNav(lan, direction)}
                    <div className="change-lan">
                        <div className="title">
                            <div className="text">{lanName}</div>
                            <IconGlobe/>
                        </div>
                        <div className="items" >{makeLang(lan)}</div>
                    </div>
                </div>
                <div className={`menu-btn ${direction} ${(top ? "big" : "")}`}>
                    <img src={menuLine} onClick={openMenu} className={"menu-btn-img" + (top ? " big" : "")} alt="menu"/>
                    <div className="bg" onClick={openMenu} style={{display: ((open) ? 'block': 'none')}}></div>
                    <div className={`menu-container ${((open) ? 'active': '')}`}>
                        <div className={`menu-btn ${direction} ${(top ? "big" : "")}`}>
                            <img src={(open ? close : menuLine)} onClick={openMenu} style={{transform: `rotate(${open ? '45' : '0'}deg)`}} className={"menu-btn-img" + (top ? " big" : "")} alt="menu"/>
                        </div>
                        <Link to="/" className="logo-menu" onClick={openMenu}>
                            <img src={props.mainLogo} alt="only voice remains"/>
                        </Link>
                        <div className="menu-items">
                            {makeNavItems()}
                        </div>
                        <div style={{flexGrow: 1}}></div>

                        <div className="change-lan">
                            <div className="title">{props.texts['language'][lan]}</div>
                            <div className="items">{makeLang(lan)}</div>
                        </div>
                        <div style={{flexGrow: 1}}></div>
                        {/* <div className="text-s">
                            شبکه های اجتماعی
                        </div>
                        <div className="socials">
                            <a href="#footer" target={"_blank"} className="item">
                                <img src={instagram} alt="podday instagram"/>
                            </a>
                            <a href="#footer" target={"_blank"} className="item">
                                <img src={twitter} alt="podday instagram"/>
                            </a>
                        </div> */}
                    </div>
                </div>
            </div>
            <div className="content">
                {props.children}
            </div>
            <div className="footer">
                <div className="container-1">
                    <div className="logo">
                        <img src={props.mainLogo} alt="farazandishan"/>
                    </div>
                    <div className="desc">
                        {props.texts['footer-desc'][lan]}
                    </div>
                </div>
                <div className="container-2">
                    {makeFooterItems()}
                </div>
                <div className="container-3">
                    <div className="logos">
                        <a referrerPolicy='origin' target='_blank'å href='https://trustseal.enamad.ir/?id=489621&Code=HqTSsnKp4nlEmapzIkayVMbEx21dfBzg'><img referrerPolicy='origin' src='https://trustseal.enamad.ir/logo.aspx?id=489621&Code=HqTSsnKp4nlEmapzIkayVMbEx21dfBzg' alt='' style={{cursor: "pointer"}} code='HqTSsnKp4nlEmapzIkayVMbEx21dfBzg'/></a>
                    </div>
                </div>
            </div>
            <div className="down">
                {props.texts['copyright'][lan]}
            </div>
        </Style>
    );
}